import { Graduation, Graduations } from '../Graduations';
export function AdminGraduations() { return <Graduations admin />; }
export function AdminGraduation() { return <Graduation admin />; }
